export const MONITOR_TOPICS = "activation.widget.topics.monitor.btn.text";
export const OWNER_NOT_CREATE_ANY_TOPIC = "activation.widget.topics.owner.not.create.any.topic.text";
